<template>
    <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
        <div class="page_header">
            <span class="page_title">{{ $t('recharge.充电统计分析') }}</span>
            <div style="flex:1;text-align: right;">
                <quickQuery :isDownload="true" @handleQuery="onQuery" @quickQuery="onQuery" @download="onExport"
                    style="text-align: right" :isNow="supportTodayDataQuery" />
            </div>
            <!-- <el-form :inline="true" :size="size" style="  flex:1;text-align: right;">
                <el-form-item :label="$t('time.timeQuery')">
                    <el-date-picker v-model="form.queryDate" type="date" value-format="yyyy-MM-dd"  :placeholder="$t('龙翼简报.选择日期')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onQuery">{{ $t('public.query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onExport">{{ $t('public.export') }}</el-button>
                </el-form-item>
            </el-form> -->
        </div>
        <el-divider></el-divider>
        <div class="page_container">
            <div v-loading="chartloading">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <!--每日充电次数分布-->
                        <div class="chart-container">
                            <div class="chart-container-chart" id="chargeCountChart"></div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="chart-container">
                            <div class="chart-container-chart" id="chargeDurationChart"></div>
                        </div>

                    </el-col>
                    <el-col :span="8">
                        <div class="chart-container">
                            <div class="chart-container-chart" id="chargeBeginTimeChart"></div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="chart-container">
                            <div class="chart-container-chart" id="chargeBeginSocChart"></div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="chart-container">
                            <div class="chart-container-chart" id="chargeSocChart"></div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="chart-container">
                            <div class="chart-container-chart" id="chargeEndSocChart"></div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="table-container">
                <el-table :size="size" v-loading="loading" :data="tableData" border style="width: 100%">
                    <el-table-column prop="carno" :label="$t('vehicle.carNo')" align="center" />
                    <el-table-column prop="BeginTime" :label="$t('recharge.充电开始时间')" align="center" />
                    <el-table-column prop="EndTime" :label="$t('recharge.充电结束时间')" align="center" />
                    <el-table-column prop="BeginSoc" :label="$t('recharge.充电开始SOC')" align="center" />
                    <el-table-column prop="EndSoc" :label="$t('recharge.充电结束SOC')" align="center" />
                    <!--秒转时分秒-->
                    <el-table-column prop="ChargeTime" :label="$t('recharge.充电时长')" align="center">
                        <template slot-scope="scope">
                            {{ secondsToHMS(scope.row.ChargeTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="ChargeCapacity" :label="$t('recharge.充电量')" align="center" />
                    <el-table-column prop="ChargeBmileage" :label="$t('recharge.充电前行驶里程')" align="center" />

                    <el-table-column prop="ChargePosition" :label="$t('recharge.充电位置')" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.ChargePosition }} <div
                                v-if="scope.row.Longitude != 0 && scope.row.Latitude != 0" class="iconfont quickLinks"
                                style="cursor: pointer;display: inline-block;" @click="mapLacation(scope.row)"><i
                                    class="iconfont icon-icon_operat_map"></i>
                            </div>
                        </template>
                    </el-table-column>

                </el-table>
                <kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total"
                    @current-change="pageChange" @size-change="sizeChange" :current-page.sync="form.PageNo">
                </kl-pagination>
            </div>
        </div>

        <el-dialog :title="$t('failure.车辆位置')" :visible.sync="mapShow">
            <div style="text-align:center">
                <KingLongMap mapId="klmap_locationMap" @LoadCompleted="MapLoadCompleted" ref="map"
                    style="width:100%;height: 450px;" />
            </div>

        </el-dialog>
    </div>
</template>
<script>
// import * as echarts from 'echarts';
import language from '@/utils/getLanguageId'
import { mapState } from 'vuex'
import settings from "@/settings";
import KingLongMap from "@/components/KingLongMap"
import quickQuery from '../components/generalOrQuickQuery.vue'
export default {
    name: 'rechargeHistory',
    components: {
        quickQuery, KingLongMap
    },
    data() {
        return {
            mapShow: false,
            mapLoaded: false,
            CarNo: '',
            Latitude: 0,
            Longitude: 0,
            loading: false,
            chartloading: false,
            tableData: [],
            total: 0,

            LanguageId: 1,
            form: {
                queryDate: this.getTodayDate(),
                PageNo: 1,
                PageSize: 10
            },
            chargeCountChart: undefined,
            chargeDurationChart: undefined,
            chargeBeginTimeChart: undefined,
            chargeBeginSocChart: undefined,
            chargeSocChart: undefined,
            chargeEndSocChart: undefined,
            beginDate: undefined,
            endDate: undefined,
        }
    },
    computed: {
        supportTodayDataQuery() {
            return settings.supportTodayDataQuery
        },
        size() {
            return this.$store.getters.size
        },
        ...mapState({
            selectedVehicles: state => state.app.vehicles.selectedVehicles,
        }),
    },
    methods: {
        //地图加载完成
        MapLoadCompleted() {
            this.mapLoaded = true;
            if (this.$refs.map) {
                this.$refs.map.clearMarkers();
                this.$refs.map.addMarker(
                    "v_10111",
                    this.CarNo,
                    this.Longitude,
                    this.Latitude
                );
                setTimeout(() => {
                    this.$refs.map.setCenter(this.Longitude, this.Latitude);
                }, 500);
            }
        },

        //车辆位置
        mapLacation(row) {
            this.mapShow = true;
            // console.log(row);
            if (this.mapLoaded) {
                if (this.$refs.map) {
                    this.$refs.map.clearMarkers();
                    this.$refs.map.addMarker(
                        "v_10111",
                        row.carno,
                        row.Longitude,
                        row.Latitude
                    );
                    setTimeout(() => {
                        this.$refs.map.setCenter(row.Longitude, row.Latitude);
                    }, 500);
                }
            } else {
                this.CarNo = row.carno;
                this.Latitude = row.Latitude;
                this.Longitude = row.Longitude;
            }

        },
        getTodayDate() {
            //往前退一天
            var date = new Date();
            date.setDate(date.getDate() - 1);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        secondsToHMS(seconds) {
            const hours = Math.floor(seconds / 3600);
            seconds %= 3600;
            const minutes = Math.floor(seconds / 60);
            seconds = Math.floor(seconds % 60);
            // 补零函数
            const pad = (num) => num.toString().padStart(2, '0');

            return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        },
        onExport() {
            this.queryList(1);
        },
        onQuery(val) {
            this.beginDate = val.beginDate;
            this.endDate = val.endDate;
            this.queryList();
            this.queryChartData();
        },
        getSelectedVehicles() {
            let vehicles = "";
            for (let k = 0; k < this.selectedVehicles.length; k++) {
                if (this.selectedVehicles[k].treeLevel == 5) {
                    vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
                }
            }
            return vehicles.substring(0, vehicles.length - 1);
        },
        queryList(isExport) {
            isExport = isExport || 0;
            if (!this.beginDate || !this.endDate) {
                this.$message.error(this.$t("time.selectQueryTime"));
                return;
            }
            let vehicles = this.getSelectedVehicles();

            this.loading = true;
            this.$api.VehicleChargeRec({
                "vehicles": vehicles,
                "BeginDate": this.beginDate,
                "EndDate": this.endDate,
                "pageNo": this.form.PageNo,
                "pageSize": isExport == 1 ? 65535 : this.form.PageSize,
                "IsExport": isExport, Language: this.LanguageId
            }, isExport == 1 ? 'blob' : 'json').then(res => {
                this.loading = false;
                if (isExport == 1) {
                    let blob = new Blob([res], {
                        type: "application/vnd.ms-excel;charset=utf-8",
                    }); // 重点代码

                    let a = document.createElement("a");
                    a.href = window.URL.createObjectURL(blob);
                    a.download = this.$t("recharge.充电记录") + '.xlsx'; // 默认文件名
                    // a.setAttribute(
                    //     "download",
                    //     "充电记录.xlsx"
                    // ); // 表名，自定义
                    // document.body.appendChild(a);
                    a.click(); // 执行下载
                    window.URL.revokeObjectURL(blob); // 释放ur

                } else {
                    this.tableData = res.data;
                    this.total = res.recordsTotal;
                }
            }).catch(err => {
                this.loading = false;
            })

        },
        sizeChange(size) {
            this.form.PageNo = 1;
            this.form.PageSize = size;
            this.queryList();
        },
        pageChange(page) {
            this.form.PageNo = page;
            this.queryList();
        },
        queryChartData() {

            let vehicles = this.getSelectedVehicles();
            this.chartloading = true;
            this.$api.VehicleChargeRecGraph({ "vehicles": vehicles, "BeginDate": this.beginDate, "EndDate": this.endDate }).then(res => {
                this.chartloading = false;
                var data_1 = [];
                if (res.data.ChargeCount) {
                    res.data.ChargeCount.forEach(element => {
                        var name = '';
                        if (element.Xaxis == ">=3")
                            name = this.$t("recharge.3次及以上")
                        else if (element.Xaxis == "2")
                            name = this.$t("recharge.2次")
                        else
                            name = this.$t("recharge.1次")
                        data_1.push({ value: element.Count, name: name })
                    });
                    const option_1 = {
                        series: [
                            {
                                name: this.$t("recharge.充电次数"), // 系列名称
                                type: 'pie', // 图表类型：饼图
                                data: data_1,
                            }
                        ]
                    };
                    // 使用配置项渲染图表
                    this.chargeCountChart.setOption(option_1);
                }
                //单次充电时间分布
                if (res.data.ChargeDuration) {
                    this.setBarChartData(res.data.ChargeDuration, this.chargeDurationChart);
                }
                //充电开始时间分布
                if (res.data.ChargeBeginTime) {
                    this.setBarChartData(res.data.ChargeBeginTime, this.chargeBeginTimeChart);
                }
                //充电开始SOC分布
                if (res.data.ChargeBeginSOC) {
                    this.setBarChartData(res.data.ChargeBeginSOC, this.chargeBeginSocChart);
                }
                //充电SOC分布
                if (res.data.ChargeSOC) {
                    this.setBarChartData(res.data.ChargeSOC, this.chargeSocChart);
                }
                //充电结束SOC分布
                if (res.data.ChargeEndSOC) {
                    this.setBarChartData(res.data.ChargeEndSOC, this.chargeEndSocChart);
                }



            }).catch(err => {
                this.loading = false;
            });
        },
        setBarChartData(data, chart) {
            var xAxis_3 = [];
            var data_3 = [];

            data.forEach(element => {
                xAxis_3.push(element.Xaxis)
                data_3.push(element.Count)
            });

            const option_3 = {
                xAxis: {
                    type: 'category', // 类目轴
                    data: xAxis_3, // X 轴数据                   
                },
                series: [
                    {
                        name: this.$t("recharge.频次"), // 系列名称
                        type: 'bar', // 图表类型：柱状图                 
                        data: data_3, // 数据（根据需求调整）                        
                    }
                ]
            };

            // 使用配置项渲染图表
            chart.setOption(option_3);
        },
        initChart() {
            // 基于准备好的 DOM，初始化 ECharts 实例
            this.initChargeCountChart();
            this.initChargeDurationChart();
            this.initChargeBeginTimeChart();
            this.initChargeBeginSocChart();
            this.initChargeSocChart();
            this.initChargeEndSocChart();

            this.queryChartData();

        },
        initChargeEndSocChart() {
            this.chargeEndSocChart = echarts.init(document.getElementById('chargeEndSocChart'));

            const option = {
                title: {
                    text: this.$t("recharge.充电结束SOC分布"), // 图表标题
                    left: 'left' // 标题居左
                },
                tooltip: {
                    trigger: 'axis', // 鼠标悬浮提示（坐标轴触发）
                    axisPointer: {
                        type: 'shadow' // 阴影指示
                    }
                },
                grid: {
                    bottom: 20,
                },
                xAxis: {
                    type: 'category', // 类目轴
                    data: [], // X 轴数据
                    axisLabel: {
                        color: '#333' // X 轴文字颜色
                    }
                },
                yAxis: {
                    type: 'value', // 数值轴
                    name: this.$t("recharge.频次"), // Y 轴名称
                    axisLabel: {
                        color: '#333' // Y 轴文字颜色
                    }
                },
                series: [
                    {
                        name: this.$t("recharge.频次"), // 系列名称
                        type: 'bar', // 图表类型：柱状图
                        barWidth: 15,
                        data: [], // 数据（根据需求调整）
                        itemStyle: {
                            color: '#409EFF', // 柱状图颜色
                            borderRadius: [6, 6, 0, 0] // 圆角
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10, // 高亮时的阴影模糊
                                shadowOffsetX: 0, // 阴影水平偏移
                                shadowColor: 'rgba(0, 0, 0, 0.5)' // 阴影颜色
                            }
                        }
                    }
                ]
            };

            // 使用配置项渲染图表
            this.chargeEndSocChart.setOption(option);

            // 监听窗口 resize 事件，自适应图表大小
            window.addEventListener('resize', () => {
                this.chargeEndSocChart.resize();
            });
        },
        initChargeSocChart() {
            this.chargeSocChart = echarts.init(document.getElementById('chargeSocChart'));

            const option = {
                title: {
                    text: this.$t("recharge.充入SOC分布"), // 图表标题
                    left: 'left' // 标题居左
                },
                tooltip: {
                    trigger: 'axis', // 鼠标悬浮提示（坐标轴触发）
                    axisPointer: {
                        type: 'shadow' // 阴影指示
                    }
                },
                grid: {
                    bottom: 20,
                },
                xAxis: {
                    type: 'category', // 类目轴
                    data: [], // X 轴数据
                    axisLabel: {
                        color: '#333' // X 轴文字颜色
                    }
                },
                yAxis: {
                    type: 'value', // 数值轴
                    name: this.$t("recharge.频次"), // Y 轴名称
                    axisLabel: {
                        color: '#333' // Y 轴文字颜色
                    }
                },
                series: [
                    {
                        name: this.$t("recharge.频次"), // 系列名称
                        type: 'bar', // 图表类型：柱状图
                        barWidth: 15,
                        data: [], // 数据（根据需求调整）
                        itemStyle: {
                            color: '#409EFF', // 柱状图颜色
                            borderRadius: [6, 6, 0, 0] // 圆角
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10, // 高亮时的阴影模糊
                                shadowOffsetX: 0, // 阴影水平偏移
                                shadowColor: 'rgba(0, 0, 0, 0.5)' // 阴影颜色
                            }
                        }
                    }
                ]
            };

            // 使用配置项渲染图表
            this.chargeSocChart.setOption(option);

            // 监听窗口 resize 事件，自适应图表大小
            window.addEventListener('resize', () => {
                this.chargeSocChart.resize();
            });
        },
        initChargeBeginSocChart() {
            this.chargeBeginSocChart = echarts.init(document.getElementById('chargeBeginSocChart'));

            const option = {
                title: {
                    text: this.$t("recharge.充电起始SOC分布"), // 图表标题
                    left: 'left' // 标题居左
                },
                tooltip: {
                    trigger: 'axis', // 鼠标悬浮提示（坐标轴触发）
                    axisPointer: {
                        type: 'shadow' // 阴影指示
                    }
                },
                grid: {
                    bottom: 20,
                },
                xAxis: {
                    type: 'category', // 类目轴
                    data: [], // X 轴数据
                    axisLabel: {
                        color: '#333' // X 轴文字颜色
                    }
                },
                yAxis: {
                    type: 'value', // 数值轴
                    name: this.$t("recharge.频次"), // Y 轴名称
                    axisLabel: {
                        color: '#333' // Y 轴文字颜色
                    }
                },
                series: [
                    {
                        name: this.$t("recharge.频次"), // 系列名称
                        type: 'bar', // 图表类型：柱状图
                        barWidth: 15,
                        data: [], // 数据（根据需求调整）
                        itemStyle: {
                            color: '#409EFF', // 柱状图颜色
                            borderRadius: [6, 6, 0, 0] // 圆角
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10, // 高亮时的阴影模糊
                                shadowOffsetX: 0, // 阴影水平偏移
                                shadowColor: 'rgba(0, 0, 0, 0.5)' // 阴影颜色
                            }
                        }
                    }
                ]
            };

            // 使用配置项渲染图表
            this.chargeBeginSocChart.setOption(option);

            // 监听窗口 resize 事件，自适应图表大小
            window.addEventListener('resize', () => {
                this.chargeBeginSocChart.resize();
            });
        },
        initChargeBeginTimeChart() {
            //充电时长分布
            this.chargeBeginTimeChart = echarts.init(document.getElementById('chargeBeginTimeChart'));

            const option = {
                title: {
                    text: this.$t("recharge.充电起始时间分布(00:00-24:00)"), // 图表标题
                    left: 'left' // 标题居左
                }, grid: {
                    bottom: 20,
                },
                tooltip: {
                    trigger: 'axis', // 鼠标悬浮提示（坐标轴触发）
                    axisPointer: {
                        type: 'shadow' // 阴影指示
                    }
                },
                xAxis: {
                    type: 'category', // 类目轴
                    data: [], // X 轴数据
                    axisLabel: {
                        color: '#333' // X 轴文字颜色
                    }
                },
                yAxis: {
                    type: 'value', // 数值轴
                    name: this.$t("recharge.频次"), // Y 轴名称
                    axisLabel: {
                        color: '#333' // Y 轴文字颜色
                    }
                },
                series: [
                    {
                        name: this.$t("recharge.频次"), // 系列名称
                        type: 'bar', // 图表类型：柱状图
                        barWidth: 15, // 设置柱状图宽度（像素值）
                        data: [], // 数据（根据需求调整）
                        itemStyle: {
                            color: '#409EFF', // 柱状图颜色
                            borderRadius: [6, 6, 0, 0] // 圆角
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10, // 高亮时的阴影模糊
                                shadowOffsetX: 0, // 阴影水平偏移
                                shadowColor: 'rgba(0, 0, 0, 0.5)' // 阴影颜色
                            }
                        }
                    }
                ]
            };

            // 使用配置项渲染图表
            this.chargeBeginTimeChart.setOption(option);

            // 监听窗口 resize 事件，自适应图表大小
            window.addEventListener('resize', () => {
                this.chargeBeginTimeChart.resize();
            });
        },
        initChargeDurationChart() {
            //充电时长分布
            this.chargeDurationChart = echarts.init(document.getElementById('chargeDurationChart'));

            // 配置项
            const option = {
                title: {
                    text: this.$t("recharge.单次充电时间分布(h)"), // 图表标题
                    left: 'left' // 标题居左
                }, grid: {
                    bottom: 20,
                },
                tooltip: {
                    trigger: 'axis', // 鼠标悬浮提示（坐标轴触发）
                    axisPointer: {
                        type: 'shadow' // 阴影指示
                    }
                },
                xAxis: {
                    type: 'category', // 类目轴
                    data: [], // X 轴数据
                    axisLabel: {
                        color: '#333' // X 轴文字颜色
                    }
                },
                yAxis: {
                    type: 'value', // 数值轴
                    name: this.$t("recharge.频次"), // Y 轴名称
                    axisLabel: {
                        color: '#333' // Y 轴文字颜色
                    }
                },
                series: [
                    {
                        name: this.$t("recharge.频次"), // 系列名称
                        type: 'bar', // 图表类型：柱状图
                        barWidth: 15, // 设置柱状图宽度（像素值）
                        data: [], // 数据（根据需求调整）
                        itemStyle: {
                            color: '#409EFF', // 柱状图颜色
                            borderRadius: [6, 6, 0, 0] // 圆角
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10, // 高亮时的阴影模糊
                                shadowOffsetX: 0, // 阴影水平偏移
                                shadowColor: 'rgba(0, 0, 0, 0.5)' // 阴影颜色
                            }
                        }
                    }
                ]
            };

            // 使用配置项渲染图表
            this.chargeDurationChart.setOption(option);

            // 监听窗口 resize 事件，自适应图表大小
            window.addEventListener('resize', () => {
                this.chargeDurationChart.resize();
            });
        },
        initChargeCountChart() {
            //充电次数分布
            this.chargeCountChart = echarts.init(document.getElementById('chargeCountChart'));

            const customColors = [
                '#1461E1', //  - 3次及以上
                '#09B2F3', //  - 2次
                '#21C189'  //  - 1次
            ];
            // 配置项
            const option = {
                title: {
                    text: this.$t("recharge.每日充电次数分布"), // 图表标题
                    left: 'left' // 标题居中
                }, grid: {
                    bottom: 20,
                },
                tooltip: {
                    trigger: 'item' // 鼠标悬浮提示
                },
                legend: {
                    orient: 'vertical', // 图例垂直排列
                    right: 10, // 图例居右
                    top: 'center' // 图例垂直居中
                },
                color: customColors, // 设置自定义颜色
                series: [
                    {
                        name: this.$t("recharge.充电次数"), // 系列名称
                        type: 'pie', // 图表类型：饼图
                        radius: ['40%', '70%'], // 环形图内外半径
                        center: ['30%', '50%'], // 图表中心位置
                        label: {
                            show: true, // 显示标签
                            position: 'inner', // 标签位置：内部
                            formatter: '{c}辆' // 标签格式：显示数据 + “辆”
                        },
                        data: [

                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10, // 高亮时的阴影模糊
                                shadowOffsetX: 0, // 阴影水平偏移
                                shadowColor: 'rgba(0, 0, 0, 0.5)' // 阴影颜色
                            }
                        }
                    }
                ]
            };

            // 使用配置项渲染图表
            this.chargeCountChart.setOption(option);

            // 监听窗口resize事件，自适应图表大小
            window.addEventListener('resize', () => {
                this.chargeCountChart.resize();
            });
        },
        resizeChart() {





            // 图表自适应大小
            this.chargeCountChart.resize();
            // 充电结束状态分布图表自适应大小            
            this.chargeBeginTimeChart.resize();
            // 充电持续时间分布图表自适应大小            
            this.chargeDurationChart.resize();
            // 充电结束状态分布图表自适应大小            
            this.chargeBeginSocChart.resize();
            // 充电结束状态分布图表自适应大小            
            this.chargeSocChart.resize();
            this.chargeEndSocChart.resize();

        },
    },
    activated() {
        // 组件激活时重新初始化图表
        this.resizeChart();
    },
    mounted() {
        const currentPath = this.$route.path
        // 从全局变量中取出对应路由的开始时间
        const startTime = settings.routeStartTime[currentPath]
        if (startTime) {
            // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
            const renderTime = Date.now() - startTime
            console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
            // 可选：上报到后端或日志系统
            // reportRenderTime(currentPath, renderTime)

            // 清除已计算的开始时间，避免重复计算
            delete settings.routeStartTime[currentPath]
        }
        this.LanguageId = language(this.$store.getters.locale)

        this.initChart();



    }
}
</script>
<style scoped>
.chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D9E4F8;

    margin-bottom: 20px;
}

.chart-container-chart {
    width: 100%;
    height: 280px;
}
</style>